import {reject, isNil} from 'ramda';

import {CustomerAdvancedSearchResultResponseBody} from '@dms/api/customer';

import {Nullish} from 'shared/web';

export const getAdvancedCustomerEmails = (
  customer: CustomerAdvancedSearchResultResponseBody | Nullish
) => {
  const emails =
    customer?.discriminator === 'BUSINESS'
      ? customer?.contacts.flatMap((contact) => contact.email)
      : [customer?.foundingPerson?.email];

  const uniqueEmails = new Set(reject(isNil, emails ?? []));

  return Array.from(uniqueEmails).map((email) => ({value: email, label: email}));
};
